import {useMemo} from 'react';
import usePlace from './usePlace';

const useListicleImagesModal = (list: HumboList, placeId: string | null) => {
  const openedPlace: Partial<Place> = useMemo(
    () => list.places.map((pR) => pR.place).find((p) => p._id === placeId),
    [placeId]
  );

  const {place: loadedPlace} = usePlace(openedPlace?.countryCode, openedPlace?.nameId);

  const place = loadedPlace || openedPlace;

  return {place};
};

export default useListicleImagesModal;
